import { createAppSlice } from 'app/createAppSlice'
import { getDetailProfile, getPricing } from './dashboardAction'

export const NAVBAR_STORAGE_KEY = 'PMB_navbar_expanded'

export const getInitialNavbarState = () => {
  if (typeof window === 'undefined') return false
  const width = window.innerWidth

  // Mobile: Hidden / collapsed
  if (width < 768) {
    return false
  }

  // Returning user: Remember their previous choice
  try {
    const saved = localStorage.getItem(NAVBAR_STORAGE_KEY)
    if (saved !== null) {
      return saved === 'true'
    }
  } catch (e) {
    console.error('Error reading navbar state from localStorage:', e)
  }

  // Desktop / large screen: Expanded
  if (width >= 1100) {
    return true
  }

  // Tablet: Collapsed
  return false
}

const initialState = {
  isOpenSidebarWithdraw: false,
  profile: {
    isLoading: false,
    data: null,
  },
  balance: {
    talangin: {
      isLoading: false,
    },
    uangBelanja: {},
    uangUsaha: {},
  },
  loading: false,
  pricing: [],
  detail: {},
  isOpenBanner: false,
  bannerMessage: '',
  bannerType: 'success',
  isOpenNavbar: getInitialNavbarState(),
  ownerData: {},
  cashPayment: false,
  isOpenSidebarFilter: false,
  isV3: false,
  individualUser: false,
  tagPaginationManual: {
    size: 10,
    page: 0,
    selectedContact: undefined,
    trxType: undefined,
  },
  tag: {
    size: 10,
    page: 0,
    type: 'BUY',
    sortby: 'createdAt',
    sortdir: 'desc',
    status: 'Aktif',
    from: undefined,
    to: undefined,
    filtertype: 'sellerid',
    filtertypevalue: undefined,
    s: undefined,
    filterPicUserId: undefined,
  },
  selectedContact: undefined,
  isCustomDate: false,
  isOpenModalInbox: false,
  dataInbox: null,
  dataTrx: null,
  modalEditNoTrx: false,
  modalEditProject: false,
}

export const dashboardSlice = createAppSlice({
  name: 'dashboard',
  initialState,
  reducers: (create) => ({
    addBalance: create.reducer((state, { payload }) => {
      state.balance.talangin = payload.talangin
      state.balance.uangBelanja = payload.wallet1
      state.balance.uangUsaha = payload.wallet2
      state.cashPayment = payload.cashPayment
    }),
    toggleSidebarWithdraw: create.reducer((state, { payload }) => {
      state.isOpenSidebarWithdraw = !state.isOpenSidebarWithdraw
    }),
    toggleBanner: create.reducer((state, { payload }) => {
      state.isOpenBanner = !state.isOpenBanner
    }),
    setMessageBanner: create.reducer((state, { payload }) => {
      state.bannerMessage = payload
    }),
    setBannerType: create.reducer((state, { payload }) => {
      state.bannerType = payload
    }),
    setTypeFetch: create.reducer((state, { payload }) => {
      state.tag.type = payload
    }),
    setProfile: create.reducer((state, { payload }) => {
      state.profile = payload
    }),
    setIndividualUser: create.reducer((state, { payload }) => {
      state.individualUser = payload
    }),
    setOwnerData: create.reducer((state, { payload }) => {
      state.ownerData = payload
    }),
    setCompanyLogo: create.reducer((state, { payload }) => {
      state.ownerData = {
        ...state.ownerData,
        companyLogo: payload,
      }
    }),
    setCompanyInfo: create.reducer((state, { payload }) => {
      state.ownerData = {
        ...state.ownerData,
        ...payload,
      }
    }),
    toggleNavbar: create.reducer((state, { payload }) => {
      const nextState = typeof payload === 'boolean' ? payload : !state.isOpenNavbar
      state.isOpenNavbar = nextState

      // Persist returning user's choice on desktop/tablet (not on mobile drawer)
      if (typeof window !== 'undefined' && window.innerWidth >= 768) {
        try {
          localStorage.setItem(NAVBAR_STORAGE_KEY, String(nextState))
        } catch (e) {
          console.error('Error saving navbar state to localStorage:', e)
        }
      }
    }),
    toggleSidebarFilter: create.reducer((state, { payload }) => {
      state.isOpenSidebarFilter = !state.isOpenSidebarFilter
    }),
    setIsV3: create.reducer((state, { payload }) => {
      state.isV3 = payload
    }),
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    setPaginationTag: create.reducer((state, { payload }) => {
      state.tagPaginationManual = { ...state.tagPaginationManual, ...payload }
    }),
    setIsCustomDate: create.reducer((state, { payload }) => {
      state.isCustomDate = payload
    }),
    toggleModalInbox: create.reducer((state, { payload }) => {
      state.isOpenModalInbox = payload ?? !state.isOpenModalInbox
    }),
    setDataInbox: create.reducer((state, { payload }) => {
      state.dataInbox = payload
    }),
    setSelectedContact: create.reducer((state, { payload }) => {
      state.selectedContact = payload
    }),
    setDataTrx: create.reducer((state, { payload }) => {
      state.dataTrx = payload
    }),
    toggleModalNoTrx: create.reducer((state, { payload }) => {
      state.modalEditNoTrx = !state.modalEditNoTrx
    }),
    toggleModalEdithProject: create.reducer((state, { payload }) => {
      state.modalEdithProject = !state.modalEdithProject
    }),
  }),
  extraReducers: (builder) => {
    builder.addCase(getPricing.fulfilled, (state, { payload }) => {
      state.pricing = payload
      state.loading = false
    })
    builder.addCase(getPricing.pending, (state, { payload }) => {
      state.loading = true
    })
    builder.addCase(getPricing.rejected, (state, { payload }) => {
      state.loading = false
    })
    builder.addCase(getDetailProfile.fulfilled, (state, { payload }) => {
      state.detail = payload
      state.loading = false
    })
    builder.addCase(getDetailProfile.pending, (state, { payload }) => {
      state.loading = true
    })
    builder.addCase(getDetailProfile.rejected, (state, { payload }) => {
      state.loading = false
    })
  },
})

export const {
  toggleSidebarWithdraw,
  addBalance,
  toggleBanner,
  setMessageBanner,
  setBannerType,
  setTypeFetch,
  setProfile,
  setOwnerData,
  setCompanyLogo,
  setCompanyInfo,
  toggleNavbar,
  toggleSidebarFilter,
  setIsV3,
  setFetchOption,
  setIndividualUser,
  toggleModalInbox,
  setDataInbox,
  setIsCustomDate,
  setSelectedContact,
  setDataTrx,
  setPaginationTag,
  toggleModalNoTrx,
  toggleModalEdithProject
} = dashboardSlice.actions

export default dashboardSlice.reducer
